/**
 * useSession Hook - Session Token Management
 *
 * Manages session tokens in memory (NOT localStorage for security).
 * Features:
 * - In-memory token storage via React Context (shared across all components)
 * - Token expiration checking
 * - Automatic refresh when < 5 minutes remaining
 * - Multi-tab synchronization via BroadcastChannel
 *
 * NOTE: This hook is now a thin wrapper around SessionContext.
 * The actual state management is in SessionContext.tsx to ensure
 * all components share the same session state instance.
 *
 * @see specs/002-frontend-mvp/spec.md - User Story 1
 */

import { useSessionContext } from '../context/SessionContext';

/**
 * Session Storage Hook
 *
 * Provides in-memory session token management with automatic expiration handling.
 * Uses React Context internally to share state across all components.
 */
export function useSession() {
  return useSessionContext();
}

export default useSession;
